import React from 'react';
import { FiUser } from 'react-icons/fi';
import { toast } from '../../../Toast';
import { WidgetDef, GENERATE_NOTE_SINGLE } from '../types';
import { DemoHead } from '../shared';
import { SocialRow } from './signUp';

// spec 697:10954
const signIn: WidgetDef = {
    slug: 'sign-in',
    name: 'Sign in',
    description: 'A sign-in card for its own page',
    icon: <FiUser />,
    title: 'Sign In Widget',
    installed: false,
    page: null,
    expectedPage: '/investors/sign-in/',
    views: null,
    metaStatus: 'Not on the website yet',
    demoPath: '/investors/sign-in/',
    addNote: 'A full sign-in card for a page of its own — /investors/sign-in/, for example. Nothing to configure: it follows the sign-in methods set on the Sign-up widget.',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_sign_in instance="sign-in"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="sign-in" data-investi="sign-in"></div>', dark: true },
        { title: '3 · If they are already signed in', text: 'The card hides itself and shows “You are signed in” with a link to their profile. The header keeps using the Account menu widget.' },
    ],
    settings: [
        { kind: 'heading', label: 'Title and text' },
        { kind: 'text', key: 'title', label: 'Title', default: 'Sign In' },
        { kind: 'text', key: 'description', label: 'Description', default: 'Manage your email alerts and see your holding' },
        { kind: 'text', key: 'button', label: 'Button label', default: 'Sign In' },
        { kind: 'heading', label: 'Sign in' },
        { kind: 'toggle', key: 'social', label: 'Sign in with social media', hint: 'Shows the “or sign up with” row', default: true },
        { kind: 'toggle', key: 'google', label: 'Sign up with Google', default: true },
        { kind: 'toggle', key: 'linkedin', label: 'Sign up with LinkedIn', default: true },
    ],
    generateNote: GENERATE_NOTE_SINGLE,
    Demo: ({ settings: s }) => <>
        <DemoHead title={String(s.title)} sub={String(s.description)} />
        <form className="wd-form" onSubmit={e => { e.preventDefault(); toast.info('Preview only: nobody was signed in'); }}>
            <input className="wd-input" type="email" placeholder="Email address" aria-label="Email address" />
            <input className="wd-input" type="password" placeholder="Password" aria-label="Password" />
            <button type="button" className="forgot" onClick={() => toast.info('Preview only: no reset email was sent')}>Forgot your password?</button>
            <button type="submit" className="wd-btn-navy">{String(s.button)}</button>
            <SocialRow s={s} divider="or sign in with" />
            <p className="foot">New here? Create an account and we will email you a password.</p>
        </form>
    </>,
};

export default signIn;
